unit share.system.classes;

interface

uses
  System.Generics.Collections;

type
  TSysAutoMailView  = class   //Auto email view
    private
      FAutoMail_Auto : Integer;
      FSlnCode : String;
      FReportSystem  : Integer;
      FCompany : String;
      FPeriodNo : Integer;
      FPeriodType : Integer;
      FLastDate : TDate;
      FNextDate : TDate;
      FChangeDate : TDate;
      FUserNotice : Boolean;
      FUserEmail : Boolean;
      FReportDesc : string;
      FPeriodTypeDesc : string;
      FCRName : string;
    published
      property AutoMail_Auto : Integer read FAutoMail_Auto write FAutoMail_Auto;
      property SLnCode : String read FSLNCODE write FSLNCODE;
      property ReportSystem  : Integer read FREPORTSYSTEM write FREPORTSYSTEM;
      property Company : String read FCOMPANY write FCOMPANY;
      property PeriodNo : Integer read FPERIODNO write FPERIODNO;
      property PeriodType : Integer read FPERIODTYPE write FPERIODTYPE;
      property LastDate : TDate read FLASTDATE write FLASTDATE;
      property NextDate : TDate read FNEXTDATE write FNEXTDATE;
      property ChangeDate : TDate read FCHANGEDATE write FCHANGEDATE;
      property UserNotice : Boolean read FUSERNOTICE write FUSERNOTICE;
      property UserEmail : Boolean read FUSEREMAIL write FUSEREMAIL;
      property ReportDesc : String read FReportDesc write FReportDesc;
      property PeriodTypeDesc : String read FPeriodTypeDesc write FPeriodTypeDesc;
      property CRName : String read Fcrname write Fcrname;
  end;

  TSysAutoMailInsert = class
    Private
      FSLnCode : String;
      FUserCode : string;
      FReportSystem : Integer;
      FCompany : string;
      FPeriodNo :Integer;
      FPeriodType : Integer;
      FLastDate: TDate;
      FNextDate : TDate;
      FChangeDate : TDate;
      FUserNotic : Boolean;
      FUserEmail : Boolean;
    published
      Property SLnCode :  String read FSLnCode write FSLnCode;
      property UserCode : String read FUserCode write FUserCode;
      property ReportSystem  : Integer read FReportSystem write FReportSystem;
      property Company : String read FCompany write FCompany;
      property PeriodNo : Integer read FPeriodNo write FPeriodNo;
      property PeriodType : Integer read FPeriodType write FPeriodType;
      property LastDate : TDate read FLastDate write FLastDate;
      property NextDate : TDate read FNextDate write FNextDate;
      property ChangeDate : TDate read FChangeDate write FChangeDate;
      property UserNotice : Boolean read FUserNotic write FUserNotic;
      property UserEmail : Boolean read FUserEmail write FUserEmail;
  end;

  TSysAutoMailEdit = class
    Private
      FAutoMail_Auto : Integer;
      FUserCode : string;
      FReportSystem : Integer;
      FCompany : string;
      FPeriodNo :Integer;
      FPeriodType : Integer;
      FLastDate: TDate;
      FNextDate : TDate;
      FChangeDate : TDate;
      FUserNotic : Boolean;
      FUserEmail : Boolean;
    published
      property AutoMail_Auto : Integer read FAutoMail_Auto write FAutoMail_Auto;
      property UserCode : String read FUserCode write FUserCode;
      property ReportSystem  : Integer read FReportSystem write FReportSystem;
      property Company : String read FCompany write FCompany;
      property PeriodNo : Integer read FPeriodNo write FPeriodNo;
      property PeriodType : Integer read FPeriodType write FPeriodType;
      property LastDate : TDate read FLastDate write FLastDate;
      property NextDate : TDate read FNextDate write FNextDate;
      property ChangeDate : TDate read FChangeDate write FChangeDate;
      property UserNotice : Boolean read FUserNotic write FUserNotic;
      property UserEmail : Boolean read FUserEmail write FUserEmail;
  end;

  TReportigSystem = class
    Private
      FAutoNumber : integer;
      FDescription : String;
    Published
      property AutoNumber : Integer read FAutoNumber write FAutoNumber;
      property Description : String read FDescription write FDescription;
  end;

  TPeriodType = class
    Private
      FPeriodType_Auto : integer;
      FDescription : String;
    Published
      property PeriodType_Auto : Integer read FPeriodType_Auto write FPeriodType_Auto;
      property Description : String read FDescription write FDescription;
  end;

  TFleetTypes = class
    private
      FAutoNo : integer;
      FDescription : string;

    published
      property AutoNo : integer read FAutoNo write FAutoNo;
      property Description : string read Fdescription write FDescription;

  end;

  TSysCostGroupsView = class
    private
      FCode : integer;
      FDescription :  String;
      FSuspended :  Boolean;
    Published
      property Code : Integer read FCode write FCode;
      property Description : String read FDescription write FDescription;
      property Suspended : Boolean read FSuspended write FSuspended;
  end;

  TSysCostGroupDetailsView = class
    private
      FCostGroupMo : Integer;
      FFleetType : Integer;
      FValueType : Integer;
      FSystemType : Integer;
      FGLCode : String;
    published
      property CostGroupMo : Integer read FCostGroupMo write FCostGroupMo;
      property FleetType : Integer read FFleetType write FFleetType;
      property ValueType : Integer read FValueType write FValueType;
      property SystemType : Integer read FSystemType write FSystemType;
      property GLCode : String read FGLCode write FGLCode;

  end;

  TSysCostGroupDetailsInsert = class
    private
      FCostGroupMo : Integer;
      FFleetType : integer;
      FValuetype : Integer;
      FSystemType : Integer;
      FGLCode : String;
    Published
      property CostGroupMo : Integer read FCostGroupMo write FCostGroupMo;
      property FleetType : Integer read FFleetType write FFleetType;
      property ValueType : Integer read FValueType write FValueType;
      property SystemType : Integer read FSystemType write FSystemType;
      property GLCode : String read FGLCode write FGLCode;

  end;

  TSysCostGroupDetailsEdit = class
    private
      FCostGroup_Auto : Integer;
      FCostGroupMo : Integer;
      FFleetType : integer;
      FValuetype : Integer;
      FSystemType : Integer;
      FGLCode : String;
    Published
      property CostGroup_Auto : Integer read FCostGroup_Auto write FCostGroup_Auto;
      property CostGroupMo : Integer read FCostGroupMo write FCostGroupMo;
      property FleetType : Integer read FFleetType write FFleetType;
      property ValueType : Integer read FValueType write FValueType;
      property SystemType : Integer read FSystemType write FSystemType;
      property GLCode : String read FGLCode write FGLCode;

  end;

  TsysFinancialPeriodsSetupView = class
    private
      FSystemType : String;
      FOpenPeriod : Integer;
      FClosePeriod : Integer;
      FRollon : Boolean;
      FDescription : String;
      FCloseLast : Boolean;
      FMonthEndDone : Boolean;
      FMonthEndDate : TDateTime;
      FMonthEndUser : String;
      FLastMonthEnd : Integer;
      FCutOffDate : TDate;
      FCurrentMonthEnd : Integer;
      FDoCutOff : Boolean;
    published
      property SystemType : String read FSystemType write FSystemtype;
      property OpenPeriod : Integer read FOpenPeriod write FOpenPeriod;
      property ClosePeriod : Integer read FClosePeriod write FClosePeriod;
      property Rollon : Boolean read FRollon write FRollon;
      property Description : String read FDescription write FDescription;
      property CloseLast : Boolean read FCloseLast write FCloseLast;
      property MonthEndDone : Boolean read FMonthEndDone write FMonthEndDone;
      property MonthEndDate : TDateTime read FMonthEndDate write FMonthEndDate;
      property MonthEndUser : String read FMonthEndUser write FMonthEndUser;
      property LastMonthEnd : Integer read FLastMonthEnd write FLastMonthEnd;
      property CutOffDate : TDate read FCutOffDate write FCutOffDate;
      property CurrentMonthEnd : Integer read FCurrentMonthEnd write FCurrentMonthEnd;
      property DoCutOff : Boolean read FDoCutOff write FDoCutOff;

  end;

  TsysFinancialperiodCutOffDateEdit = class
    private
      FSystem : String;
      FRollon : Boolean;
      FCloseLast : Boolean;
      FMonthEndDone : Boolean;
      FDoCutOff : boolean;
    published
      property System : String read FSystem write FSystem;
      property Rollon : Boolean read FRollon write FRollon;
      property CloseLast : Boolean read FCloseLast write FCloseLast;
      property MonthEndDone : Boolean read FMonthEndDone write FMonthEndDone;
      property DoCutOff : Boolean read FDoCutOff write FDoCutOff;

  end;

  TValueTypes = class
    private
      FAutoNo : Integer;
      FDescription : String;

    Published
      property AutoNo : Integer read FAutoNo write FAutoNo;
      property Description : String read FDescription write FDescription;
  end;

  TSystemTypes = class
    private
      FSystemNO : Integer;
      FDescription : String;
    Published
      property SystemNO : Integer read FSystemNO write FSystemNO;
      property Description : String read FDescription write FDescription;
  end;

  TGLAcounts = class
    private
      FGLCode : String;
      FGLDescription : String;
    Published
      property GLCode : String read FGLCode write FGLCode;
      property GLDescription : String read FGLDescription write FGLDescription;
  end;

  TCostGroups = class
    private
      FCode : Integer;
      FDescripiton : String;
      FSuspended : String;
    published
      Property Code : Integer read FCode write Fcode;
      Property Description : String read FDescripiton write FDescripiton;
      Property Suspended : String read FSuspended Write FSuspended;
  end;

  TSysCostGroupDetails_PK = class
    private
      FFleetType : Integer;
      FValueType : Integer;
      FSystemType : Integer;
      FGLCode : String;
    published
      property FleetType : Integer read FFleetType write FFleetType;
      property ValueType : Integer read FValueType write FValueType;
      property SystemType : Integer read FSystemType write FSystemType;
      property GLCode : String read FGLCode write FGLCode;

  end;
implementation

end.
